import React, { useEffect, useState } from "react";
import { Divider, Modal, Select } from "antd";
import { Controller, useForm } from "react-hook-form";
import CustomSelect from "../../../../../../common/input/custom-select/custom-select";
import CustomTextfield from "../../../../../../common/input/custom-textfield/custom-textfield";
import { getTeacherListData } from "../../../../../../services/reportCard";

const NotifyTeacherModal = ({ visible, onCancel, onSubmit }) => {
  const [teacherList, setTeacherList] = useState([]);
  const { control, handleSubmit, reset } = useForm({
    mode: "onChange",
    defaultValues: {
      teacher: "",
      comment: ""
    },
  });

  useEffect(() => {
    getTeacherList();
  }, []);

  const getTeacherList = async () => {
    try {
      const response = await getTeacherListData();
      const teachers = response?.data?.data || [];
      setTeacherList(teachers);
    } catch (error) {
      console.error("Error fetching teacher list:", error);
    }
  };

  const handleClose = () => {
    reset();
    onCancel();
  };

  const submitForm = async (data) => {
    const response = await onSubmit(data);
    if (response) handleClose();
  };

  return (
    <Modal
      title={
        <>
          Notify Class Teacher
          <Divider style={{ margin: "8px 0" }} />
        </>
      }
      open={visible}
      onCancel={handleClose}
      onOk={handleSubmit(submitForm)}
      okText="Submit"
      cancelText="Cancel"
    >
      <div style={{ marginBottom: 16 }}>
        <Controller
          name="teacher"
          control={control}
          rules={{ required: "Teacher is required" }}
          render={({ field, fieldState: { error } }) => (
            <CustomSelect
              {...field}
              id="teacher"
              label="Teacher"
              showRequired
              placeholder="--Select--"
              errorMessage={error?.message}
              style={{ height: "40px" }}
            >
              {teacherList?.map((teacher) => (
                <Select.Option key={teacher?.id} value={teacher?.id}>
                  {teacher?.full_name}
                </Select.Option>
              ))}
            </CustomSelect>
          )}
        />
      </div>

      <div style={{ marginBottom: 24 }}>
        <Controller
          name="comment"
          control={control}
          rules={{ required: "Comment is required" }}
          render={({ field, fieldState: { error } }) => (
            <CustomTextfield
              {...field}
              id="comment"
              label="Comment"
              showRequired
              rows={4}
              placeholder="Write your comment here..."
              showCount
              maxLength={50}
              errorMessage={error?.message}
            />
          )}
        />
      </div>
    </Modal>
  );
};

export default NotifyTeacherModal;